import { useEffect, useState } from 'react';
import { motion as Motion } from 'framer-motion';
import ConfettiCanvas from './ConfettiCanvas';
import { getRandomBuddyAsset, SLOT } from '../../lib/buddyManifest';
import { SPRING_POP } from '../../constants/motion';
import s from './LevelUpCelebration.module.css';

export default function LevelUpCelebration({ progression, onDismiss, buddySlug }) {
  const [animateIn, setAnimateIn] = useState(false);
  const [showContent, setShowContent] = useState(false);
  // Random LEVEL_UP pose, held for the overlay's lifetime.
  const [buddySrc] = useState(() => getRandomBuddyAsset(buddySlug, SLOT.LEVEL_UP));

  useEffect(() => {
    requestAnimationFrame(() => setAnimateIn(true));
    // Stagger content reveal
    const timer = setTimeout(() => setShowContent(true), 400);
    return () => clearTimeout(timer);
  }, []);

  if (!progression) return null;

  const { level, unlocks_granted } = progression;
  const hasUnlocks = unlocks_granted && unlocks_granted.length > 0;

  return (
    <div className={`${s.overlay} ${animateIn ? s.overlayIn : ''}`}>
      <ConfettiCanvas duration={4000} />

      <div className={s.content}>
        {/* Buddy — the visual anchor, above the level badge (LEVEL_UP slot).
            Inline styles + framer-motion only: no CSS module changes (constraint F). */}
        {buddySrc && (
          <Motion.img
            src={buddySrc}
            alt=""
            aria-hidden="true"
            onError={(e) => { e.target.style.display = 'none'; }}
            style={{
              width: 'clamp(160px, 44vw, 240px)',
              height: 'auto',
              objectFit: 'contain',
              marginBottom: '8px',
              filter: 'drop-shadow(0 12px 28px rgba(0, 0, 0, 0.3))',
            }}
            initial={{ opacity: 0, y: -48, scale: 0.6 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            transition={{ ...SPRING_POP, delay: 0.15 }}
          />
        )}

        {/* Level number with glow */}
        <div className={`${s.levelBadge} ${showContent ? s.badgeIn : ''}`}>
          <span className={s.levelNumber}>{level.current}</span>
        </div>

        {/* Headlines */}
        <h1 className={`${s.headline} ${showContent ? s.headlineIn : ''}`}>
          Level Up!
        </h1>
        <p className={`${s.levelName} ${showContent ? s.nameIn : ''}`}>
          {level.name}
        </p>

        {/* XP badge */}
        <div className={`${s.xpBadge} ${showContent ? s.xpIn : ''}`}>
          +100 XP
        </div>

        {/* Unlock reveals */}
        {hasUnlocks && (
          <div className={`${s.unlockSection} ${showContent ? s.unlockIn : ''}`}>
            <p className={s.unlockTitle}>New Unlocks!</p>
            {unlocks_granted.map((unlock, i) => (
              <div key={unlock.unlock_key || i} className={s.unlockItem}>
                <span className={s.unlockIcon}>🔓</span>
                <span className={s.unlockName}>{unlock.display_name || unlock.unlock_key}</span>
              </div>
            ))}
          </div>
        )}

        {/* CTA */}
        <button
          type="button"
          className={`${s.cta} ${showContent ? s.ctaIn : ''}`}
          onClick={onDismiss}
        >
          Continue
        </button>
      </div>
    </div>
  );
}
